import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { HomeService } from 'src/app/home/home.service';
import { CookieHandlerService } from 'src/app/common/services/cookieHandler.service';
import { CommonConstants } from 'src/app/common/utilities/commonConstants';
import { SessionHandlerService } from 'src/app/common/services/sessionHandler.service';
import { Formatter } from 'src/app/common/services/formatter';
import { RouteContextProvider } from 'src/app/common/services/routeContextProvider.service';
import { ActivitiHandlerService } from 'src/app/common/services/activitiHandler.service';
import { RouteHandlerService } from 'src/app/common/services/routeHandler.service';
import { SharedService } from 'src/app/common/services/sharedService';
import { DrawerComponent } from 'src/app/common/utilities/drawer/drawer.component';

@Component({
  selector: 'app-general-insurance',
  templateUrl: './general-insurance.component.html',
  styleUrls: ['./general-insurance.component.scss']
})
export class GeneralInsuranceComponent implements OnInit {

  constructor(
    private _homeService: HomeService,
    private _sessionStorage: SessionHandlerService,
    private _formatter: Formatter,
    private _routeContextProvider: RouteContextProvider,
    private _activitiHandler: ActivitiHandlerService,
    private _routerService: RouteHandlerService,
    private _cookieHandlerService: CookieHandlerService,
    private _sharedService: SharedService
  ) { }
  public showLoader: boolean = true;
  public errorMessage: string = '';
  public errorTitle: string = '';
  @ViewChildren(DrawerComponent) public drawer: QueryList<DrawerComponent>;
  public utmSource = this._routeContextProvider.GetQueryParams('utmSource');
  ngOnInit(): void {
    //below condition is added to handle general insurance url opening in same tab issue
    if(this.utmSource == 'SFDC_UCF' || this.utmSource == 'autolease'){
      this._sessionStorage.FlushAll();
    }
    
    this._sessionStorage["vehicleDetails"] = null;
    const SS1_Token = this._sessionStorage.GetSession(CommonConstants.CookieKeys.JWToken);
    
    // Create inquiries payload (handles validation internally)
    const inquiriesPayload = this.createInquiriesPayload();

    // Only proceed if payload was created successfully (not null)
    if (inquiriesPayload) {
      if (!SS1_Token) {
        this.setSystemAuthToken(CommonConstants.LOAN_PRODUCT_CODES.Motor_Insurance, inquiriesPayload);
      }
      else {
        this.createApplication(inquiriesPayload);
      }
    }
  }


  private createInquiriesPayload(): any {
    // Extract all query parameters
    const sessionId = this._routeContextProvider.GetQueryParams('sessionId');
    const productCode = this._routeContextProvider.GetQueryParams('categoryCode');
    let mobileNumber = decodeURIComponent(this._routeContextProvider.GetQueryParams('mobileNo'));
    mobileNumber = mobileNumber.replace(/ /g, '+');
    const registrationNo = this._routeContextProvider.GetQueryParams('registrationNumber');
    const product = this._routeContextProvider.GetQueryParams('product');
    this._sessionStorage.SetSession(CommonConstants.CookieKeys.product, product);
    const pinCode = this._routeContextProvider.GetQueryParams('pinCode');
    let customerName = decodeURIComponent(this._routeContextProvider.GetQueryParams('customerName'));
    customerName = customerName.replace(/ /g, '+');
    const makeModel = this._routeContextProvider.GetQueryParams('makeModel');
    const variant = this._routeContextProvider.GetQueryParams('variant');
    const fuelType = this._routeContextProvider.GetQueryParams('fuelType');
    let registrationYear = this._routeContextProvider.GetQueryParams('regYear');
    let manufacturingYear = this._routeContextProvider.GetQueryParams('manYear');
    const corporateFlag = this._routeContextProvider.GetQueryParams('corporateFlag');
    const renewalPartner = this._routeContextProvider.GetQueryParams('RenewalPartner');
    const pypNum = this._routeContextProvider.GetQueryParams('PYPNum');
    const engNum = this._routeContextProvider.GetQueryParams('EngNum');
    const chsNum = this._routeContextProvider.GetQueryParams('ChsNum');
    const pypExpDate = this._routeContextProvider.GetQueryParams('PYPExpDate');
    const productIdetifier = this._routeContextProvider.GetQueryParams('productIdetifier');
    const vehiclerefcode = this._routeContextProvider.GetQueryParams('vehiclerefcode');
    
    let firstName, middleName, lastName;
    firstName = customerName;

    try {
      // Validate and construct dates (will throw error if invalid)
      if (registrationYear != null) {
        this._sessionStorage.SetSession(CommonConstants.CookieKeys.registrationYear, registrationYear);
        registrationYear = this.constructDate(registrationYear);
      }
      if (manufacturingYear != null) {
        this._sessionStorage.SetSession(CommonConstants.CookieKeys.manufacturingYear, manufacturingYear);
        manufacturingYear = this.constructDate(manufacturingYear);
      }
    } catch (error) {
      this.showLoader = false;
      
      this.errorTitle = 'Invalid Date';
      this.errorMessage = error.message || 'An invalid date was provided. Please verify the date and try again.';
      
      setTimeout(() => {
        this.openDrawer('ProccedMessageDrawer');
      }, 100);
      
      console.error('Date validation error:', error);
      
      // Return null to prevent further execution
      return null;
    }
    
    this._sessionStorage.SetSession(CommonConstants.CookieKeys.sessionIdAutolease, sessionId);
    this._sessionStorage.SetSession(CommonConstants.CookieKeys.corporateFlag, corporateFlag);
    this._sessionStorage.SetSession(CommonConstants.CookieKeys.autoleaseUtmSource, this.utmSource);
    this._sessionStorage.SetSession(CommonConstants.CookieKeys.productIdetifier, productIdetifier);

    if (firstName && firstName.includes(' ')) {
      firstName = firstName.replace(/ /g, '+');
    }

    return {
      'payload': {
        'tabKey': null,
        'roleKey': null,
        'userKey': '',
        'mobile': decodeURIComponent(mobileNumber),
        'product': product,
        'RenewPartner': renewalPartner || null,
        'corporateFlag': corporateFlag,
        'productCategoryCode': productCode,
        'assetDetailReq': true,
        'applicationUTMParams': this._sharedService.UtmStamping(),
        'userrolekey': null,
        'registrationDt': registrationYear,
        'manufactureDt': manufacturingYear,
        'quoteCriteria': {
          'pinCode': pinCode,
          'wGIQuoteCriteria': {
            'applicationId': sessionId || null,
            'registrationNumber': registrationNo.toUpperCase(),
            'commercialVehicle': false,
            'policyExpired': 'N',
            'pinCode': pinCode,
            "firstName": firstName,
            "middleName": middleName,
            "lastName": lastName,
            'PYPExpDate': pypExpDate || null,
            'PYPNum': pypNum || null
          },
        },
        'vehicleDetails': {
          "makeModel": makeModel,
          "variant": variant,
          "fuelType": fuelType,
          "EngNum": engNum || null,
          "ChsNum": chsNum || null,
          "vehiclerefcode": vehiclerefcode || null
        }
      }
    };
  }

  private isValidDate(day: number, month: number, year: number): boolean {
    // Month range check (1-12)
    if (month < 1 || month > 12) {
      return false;
    }

    // Day range check (1-31)
    if (day < 1 || day > 31) {
      return false;
    }

    const dateObj = new Date(year, month - 1, day);

    return (
      dateObj.getFullYear() === year &&
      dateObj.getMonth() === month - 1 &&
      dateObj.getDate() === day
    );
  }

  constructDate(dateInput: string): string | null {
    if (!dateInput) {
      return null;
    }

    const today = new Date();
    const currentDay = String(today.getDate()).padStart(2, '0');
    const currentMonth = String(today.getMonth() + 1).padStart(2, '0');
    const currentYear = String(today.getFullYear());

    dateInput = dateInput.trim();

    if (dateInput.includes('-')) {
      const parts = dateInput.split('-');
      
      if (parts.length === 3) {
        // Full date: DD-MM-YYYY
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);

        // Validate the date
        if (!this.isValidDate(day, month, year)) {
          throw new Error(`Invalid date: ${dateInput}. Day (${day}) or Month (${month}) is out of range or invalid for the given year (${year}).`);
        }

        const dayStr = parts[0].padStart(2, '0');
        const monthStr = parts[1].padStart(2, '0');
        return `${year}-${monthStr}-${dayStr}`;
      } else if (parts.length === 2) {
        // Month-Year: MM-YYYY
        const month = parseInt(parts[0], 10);
        const year = parseInt(parts[1], 10);

        // Validate month only
        if (month < 1 || month > 12) {
          throw new Error(`Invalid month: ${month}. Month must be between 1 and 12.`);
        }

        const monthStr = parts[0].padStart(2, '0');
        return `${year}-${monthStr}-01`;
        // return `${year}-${monthStr}-${currentDay}`;
      }
    }

    // Year only (YYYY)
    if (dateInput.length === 4 && !isNaN(Number(dateInput))) {
      const year = parseInt(dateInput, 10);
      
      if (year < 1900 || year > 2100) {
        throw new Error(`Invalid year: ${year}. Year must be between 1900 and 2100.`);
      }

      return `${year}-${currentMonth}-01`;
      // return `${year}-${currentMonth}-${currentDay}`;
    }

    // Invalid format, return null
    return null;
  }

  private setSystemAuthToken(productCode: string, inquiriesPayload: any): void {
    this._homeService.GetSystemAuthToken({
      productCode
    }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
      if (!responseData.errorBean) {
        const tokenObj = responseData.payload.tokens[0];
        this._sessionStorage.SetSession(CommonConstants.CookieKeys.JWToken, tokenObj.token);
        this._sessionStorage.SetSession(CommonConstants.CookieKeys.GuardKey, tokenObj.guardKey);
        this._sessionStorage.SetSession(CommonConstants.CookieKeys.GuardToken, this._formatter
          .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
        this.createApplication(inquiriesPayload);
      }
    });
  }
  private createApplication(payload: any): void {
    this._activitiHandler.PostCallService(payload).subscribe((response) => {
      if (response.error != null || response.error != undefined) {
        this.openDrawer('ProccedMessageDrawer');
        this.showLoader = false;
      }
      else {
        const authtoken = response.headers.get('authtoken');
        if (authtoken) {
          this._sessionStorage.SetSession(CommonConstants.CookieKeys.JWToken, authtoken);
        }
        const nextPage = response?.nextTask?.nextTaskKey;
        const appId = response?.payload?.applicationId;
        this._sessionStorage.SetSession(CommonConstants.CookieKeys.QuoteCriteriaId, response.payload.appQuoteCriteriaId);
        if (response.nextTask.processId) {
          this._sessionStorage.SetSession(CommonConstants.CookieKeys.processId,
            this._formatter.removeDoubleQuotes(response.nextTask.processId));
        }
        this._sessionStorage.SetSession(CommonConstants.CookieKeys.LoanApplicationId, response.payload.applicationId);
        this._cookieHandlerService.SetCookie(CommonConstants.CookieKeys.LoanApplicationId, appId, appId);
        const productKey = this._sessionStorage.GetSession(CommonConstants.CookieKeys.product);
        if (nextPage === 'productListing' || nextPage === 'assetDetail') {
          this.SetSessionQuoteId(response.payload.quoteIds);
          this._routerService.RouteToNextTask(nextPage);
          if(this.utmSource == 'autolease'){
            this._sessionStorage.SetSession(CommonConstants.CookieKeys.autoLease, true);
          } else if(this.utmSource == 'SFDC_UCF'){
            this._sessionStorage.SetSession(CommonConstants.CookieKeys.sfdcUCF, true);
          }
          this._sessionStorage.SetSession(CommonConstants.CookieKeys.vehicleDetails, JSON.stringify(payload.payload.vehicleDetails))
        }
        else {
          window.scrollTo(0, 0);
          this._sessionStorage.SetSession(CommonConstants.CookieKeys.autoLease, false);
          this._sessionStorage.SetSession(CommonConstants.CookieKeys.sfdcUCF, false);
          this._routerService.RouteToNextTask(nextPage);
        }
        this.showLoader = false;
      }
    });
  }
  private SetSessionQuoteId(quoteIds: any) {
    this._sessionStorage.SetSession(CommonConstants.CookieKeys.PlanQuoteIds, JSON.stringify(quoteIds));
  }
  public openDrawer(itemId) {
    this.drawer?.filter((item, index) => {
      return (itemId === item.drawerId);
    })[0].open();
  }
  public hideDrawer(itemId) {
    this.drawer?.filter((item, index) => {
      return (itemId === item.drawerId);
    })[0].close();
  }

}
